{
  "OPTIONAL": "İsteğe bağlı",
  "BOOLEAN": {
    "YES": "Evet",
    "NO": "Hayır"
  },
  "URGENCY": {
    "HIGH": "Yüksek",
    "LOW": "Düşük"
  },
  "APP": {
    "VERSION": "Bu uygulama {version} sürümünde çalışıyor"
  },
  "BUTTONS": {
    "NEXT": "İleri",
    "SKIP": "Atla",
    "CONFIRM": "Onayla",
    "CLOSE": "Kapat",
    "CANCEL": "İptal",
    "SHOW_ALL": "Tümünü göster",
    "HIDE": "Gizle"
  },
  "FOOTER": {
    "HOME": "Ana Sayfa",
    "WORK": "İş",
    "TOOLBOXES": "Araç kutuları",
    "PROFILE": "Profil"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Henüz proje yok",
    "EMPTY_STATE_MESSAGE": "Projeler yakında görünecek."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Giriş yapıldı",
      "CHECKED_OUT": "Çıkış yapıldı",
      "CHECK_IN": "Giriş yap",
      "CHECK_OUT": "Çıkış yap"
    },
    "TO_FULFILL": "Tamamlanacaklar",
    "CHECKLISTS": "Kontrol listeleri",
    "CERTIFICATES": "Sertifikalar",
    "SAFETY_INSTRUCTIONS": "Güvenlik Talimatları",
    "TOOLBOXES": "Araç kutuları",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Aktif proje yok",
      "MESSAGE": "Henüz bir projeye kaydolmadınız. Başlamak için bir proje bulun!",
      "BUTTON": "Proje bul"
    },
    "ALERTS": "Mesajlar",
    "NO_ALERTS": "Şu anda mesaj yok",
    "CURRENT_CHECK_IN": "Şu anda giriş yapıldı",
    "LAST_PROJECT": "Son proje",
    "CHECKED_IN_AT": "{time} saatinde giriş yapıldı",
    "LAST_CHECKED_IN": "Son giriş {time} saatinde",
    "CHECKED_OUT_AT": "{time} saatinde çıkış yapıldı",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Sahadaki çalışanlar",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Oluştur"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Güvenlik Talimatları",
    "ALL_COMPLETED": "Gerekli tüm güvenlik talimatları tamamlandı"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Önceki",
    "NEXT": "İleri",
    "FINISH": "Bitir",
    "QUESTION_HINT_AT_LEAST_ONE": "Lütfen en az bir doğru cevap seçin",
    "QUESTION_HINT_ALL_CORRECT": "Lütfen tüm doğru cevapları seçin",
    "QUESTION_ERROR_ALL_CORRECT": "Bunlar doğru cevaplar değil, lütfen tekrar deneyin",
    "QUESTION_CORRECT": "Doğru cevap!",
    "QUESTION_ERROR_UNANSWERED": "Lütfen tüm sorulara doğru cevaplar verin"
  },
  "LOGIN": {
    "EMAIL_LABEL": "E-posta",
    "PASSWORD_LABEL": "Şifre",
    "EMAIL_PLACEHOLDER": "E-posta adresinizi girin",
    "PASSWORD_PLACEHOLDER": "Şifrenizi girin",
    "LOGIN_BUTTON": "Giriş yap",
    "LOG_IN": "Giriş yap",
    "FORGOT_PASSWORD": "Şifremi unuttum?",
    "LOGIN_WITH_YIVI": "Yivi ile giriş yap",
    "YIVI_HELP": "Yivi'yi kullanarak giriş yapın veya hesabınızı oluşturun.",
    "PASSWORD_LOGIN": "Parola ile giriş yap"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Şifremi unuttum",
    "DESCRIPTION": "Şifre kurtarma e-postası göndermemiz için e-posta adresinizi girin",
    "EMAIL_LABEL": "E-posta",
    "EMAIL_PLACEHOLDER": "E-posta adresinizi girin",
    "SUCCESS_MESSAGE_1": "Onay e-postasını şu adrese gönderdik:",
    "SUCCESS_MESSAGE_2": "E-postanızı kontrol edin ve devam etmek için onay bağlantısına tıklayın",
    "SUBMIT_BUTTON": "Gönder",
    "RESEND_BUTTON": "E-postayı yeniden gönder"
  },
  "RESET_PASSWORD": {
    "TITLE": "Şifreyi sıfırla",
    "DESCRIPTION": "Diğer web sitelerinde kullanmadığınız yeni, güçlü bir şifre oluşturun",
    "PASSWORD_LABEL": "Yeni şifre",
    "PASSWORD_PLACEHOLDER": "Yeni şifrenizi girin",
    "VERIFY_PASSWORD_LABEL": "Yeni şifreyi doğrula",
    "VERIFY_PASSWORD_PLACEHOLDER": "Yeni şifrenizi tekrar girin",
    "PASSWORD_MISMATCH": "Şifreler eşleşmiyor",
    "RESET_BUTTON": "Şifreyi sıfırla",
    "INVALID_TOKEN": "E-posta adresi geçersiz veya token süresi dolmuş. Lütfen yeni bir şifre sıfırlama talep edin",
    "SUCCESS_TITLE": "Başarılı!",
    "SUCCESS_MESSAGE": "Şifreniz başarıyla sıfırlandı. Artık yeni şifrenizle giriş yapabilirsiniz.",
    "LOGIN": "Giriş Yap",
    "INVALID_LINK_TITLE": "Geçersiz sıfırlama bağlantısı",
    "INVALID_LINK_MESSAGE": "Bu şifre sıfırlama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir şifre sıfırlama talep edin.",
    "REQUEST_NEW_LINK": "Yeni sıfırlama bağlantısı talep et"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Bir davetiniz var!",
      "DESCRIPTION": "Bir istihdama davet edildiniz. Ayrıntıları inceleyin ve başlamak için daveti kabul edin.",
      "SUBSCRIPT": "Bu davet bağlantısı yalnızca bir kez kullanılabilir ve 7 gün içinde geçerliliğini yitirir.",
      "BUTTON": "Daveti kabul et"
    },
    "OFFER": {
      "ORGANISATION": "Organizasyon",
      "FUNCTION": "Fonksiyon",
      "START_DATE": "Başlangıç tarihi",
      "END_DATE": "Bitiş tarihi",
      "INVITED_AS": "Davet edilme şekli"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Telefonunuzda kabul edin",
      "DESCRIPTION": "Bu daveti i-LOP uygulamasında açmak için bu kodu telefonunuzun kamerasıyla tarayın."
    },
    "SIGN_IN_TO_ACCEPT": "Kabul etmek için giriş yapın",
    "SUCCESS": {
      "TITLE": "Davet kabul edildi!",
      "DESCRIPTION": "İstihdamınız artık hesabınıza bağlı.",
      "BUTTON": "Devam et"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Zaten kabul edildi",
      "DESCRIPTION": "Bu davet zaten kabul edilmiş."
    },
    "NOT_INVITABLE": {
      "TITLE": "Davet artık geçerli değil",
      "DESCRIPTION": "Bu istihdam artık mevcut değil. Lütfen işvereninizle iletişime geçin."
    },
    "EXPIRED": {
      "TITLE": "Davetin süresi doldu",
      "DESCRIPTION": "Bu davet bağlantısının süresi dolmuş. Lütfen işvereninizden yeni bir davet göndermesini isteyin."
    },
    "INVALID_LINK": {
      "TITLE": "Geçersiz davet bağlantısı",
      "DESCRIPTION": "Bu davet bağlantısı geçersiz. Lütfen yeni bir davet talep etmek için yöneticinizle iletişime geçin."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "E-posta adresi zaten kullanımda",
      "INVALID": "E-posta adresiniz veya şifreniz yanlış",
      "TRY_LATER": "Şu anda giriş yapamazsınız, lütfen daha sonra tekrar deneyin",
      "TOKEN_NOT_VALID": "Tekrar giriş yapmanız gerekiyor",
      "YIVI_FAILED": "Yivi ile giriş yaparken bir hata oluştu"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Bu projeye zaten atanmışsınız.",
      "NOT_ASSIGNED": "Bu projeye atanmamışsınız."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Kamerayı kullanma izni yok",
      "INVALID": "QR kod geçersiz",
      "EXPIRED": "QR kodun süresi dolmuş",
      "NO_PROJECT_SELECTED": "Önce doğrulama yapacağın projeyi seç",
      "NO_PROJECT_TO_VERIFY": "Burada yürüttüğün bir proje yok, bu yüzden bu çalışanın doğrulanabileceği bir proje de yok",
      "PROJECTS_UNAVAILABLE": "Projelerin yüklenemedi. Bağlantını kontrol et ve tekrar tara",
      "IDENTITY_NOT_RESOLVED": "QR kod tek bir uygulama hesabına karşılık gelmiyor"
    },
    "AVATAR": {
      "TOO_LARGE": "Fotoğraf dosyası çok büyük. Daha küçük bir fotoğraf seçin.",
      "DIMENSIONS_TOO_LARGE": "Fotoğraf çok büyük. Daha küçük bir fotoğraf seçin.",
      "UNSUPPORTED_IMAGE_TYPE": "Bu dosya türü profil fotoğrafı olarak kullanılamaz. JPEG, PNG veya WebP bir görsel seçin.",
      "MALFORMED_IMAGE": "Fotoğraf okunamadı. Başka bir fotoğraf deneyin.",
      "INVALID_IMAGE": "Fotoğraf profil fotoğrafı olarak kullanılamaz."
    },
    "GENERIC": "Bir şeyler ters gitti",
    "NETWORK": "Sunucuya bağlanılamıyor",
    "NOT_FOUND": "Bir şey bulunamıyor",
    "UNKNOWN": "Bilinmeyen bir hata oluştu",
    "OFFLINE": "Çevrimiçi değilsiniz",
    "NOT_CHECKED_IN": "Bir projeye giriş yapmamışsınız",
    "CONTENT_OUTSTANDING": "İmzalamadan önce tüm talimatları ve toolbox’ları tamamlayın.",
    "INVALID_SIGNATURE": "Bu imza okunamadı. Lütfen tekrar çizin.",
    "NO_PROJECT_ACCESS": "Bu projeye erişiminiz yok",
    "NO_ACCESS": "Buna izniniz yok",
    "INVITATION_INVALID": "Davet bağlantısı geçerli değil.",
    "INVITATION_EXPIRED": "Davet bağlantısının süresi doldu. İşvereninizden yeni bir tane göndermesini isteyin.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Bu istihdam zaten başka bir hesaba bağlı.",
    "EMPLOYMENT_NOT_INVITABLE": "Bu istihdam artık kabul edilemez.",
    "PERSON_BINDING_CONFLICT": "Bu kişi kaydı başka bir uygulama hesabıyla ilişkili. Yöneticinizle iletişime geçin.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Bu çalışanın eksik gereklilikleri var, bu yüzden içeri alınması istisna olarak kaydedilmelidir.",
    "PERSON_NOT_BOUND": "Bu kişinin henüz bir uygulama hesabı yok.",
    "PERSON_NO_PROJECT_ACCESS": "Taranan kişinin bu projeye erişimi yok",
    "PERSON_ALREADY_CHECKED_IN": "Taranan kişi bu projeye zaten giriş yapmış",
    "SUBJECT_NOT_FOUND": "Taranan kişinin hesabı bulunamadı",
    "SUBJECT_NOT_CHECKED_IN": "Bu çalışan bu projeye giriş yapmamış, bu yüzden burada içeri alınamaz"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Taranıyor",
    "SCAN_QR_CODE": "QR kod tara",
    "RETRY_SCAN_QR_CODE": "QR kodu tekrar tara",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Ayarları açın ve kamerayı kullanma izni verin",
    "OPEN_SETTINGS": "Ayarları aç",
    "SCAN_AGAIN": "Sonrakini tara",
    "VERIFY_AGAINST": "Şu proje için doğrula",
    "VERIFY_AGAINST_PLACEHOLDER": "Bir proje seç"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Bir seçenek seçin",
    "DEFAULT_MULTISELECT_TITLE": "Bir veya daha fazla seçenek seçin"
  },
  "ONBOARDING": {
    "LOG_IN": "Giriş yap",
    "WELCOME_MESSAGE": "Öğrenme ve geliştirme platformuna hoş geldiniz."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Hesabınızı tamamlayın",
    "DESCRIPTION": "Kimlik bilgilerinizi Yivi'den aldık. Devam etmek için kalan iLOP bilgilerini tamamlayın.",
    "BIRTH_DATE": "Doğum tarihi",
    "GENDER": "Cinsiyet",
    "SUBMIT": "Hesap oluştur",
    "CANCEL": "İptal"
  },
  "GENDER": {
    "MALE": "Erkek",
    "FEMALE": "Kadın",
    "OTHER": "Diğer"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Kaydedildi"
  },
  "NOTIFICATION": {
    "DISMISS": "Kapat"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Kişisel bilgiler",
    "NAME": "Ad",
    "SURNAME": "Soyad",
    "NICKNAME": "Tercih edilen ad",
    "NICKNAME_PLACEHOLDER": "Tercih ettiğiniz adı girin (isteğe bağlı)",
    "CERTIFICATES": "Sertifikalar",
    "SAVE": "Kaydet",
    "SELECT_FUNCTION": "Fonksiyon seç",
    "LOGOUT": "Çıkış yap",
    "TOAST": {
      "SAVED": "Kişisel bilgiler kaydedildi",
      "ERROR": "Kişisel bilgileri kaydederken hata oluştu"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Ne yapmak istiyorsunuz?",
      "CHANGE_LABEL": "Profil fotoğrafını değiştir",
      "DELETE_LABEL": "Profil fotoğrafını sil",
      "CANCEL_LABEL": "İptal",
      "RESIZE_ERROR": "Fotoğraf işlenemedi. Başka bir fotoğraf deneyin.",
      "CROP_TITLE": "Fotoğrafı kırp",
      "CROP_CONFIRM": "Fotoğrafı kullan",
      "CROP_ZOOM_LABEL": "Yakınlaştırma"
    },
    "SETTINGS": "Ayarlar",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Şifreyi değiştir"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Mevcut şifre",
      "PLACEHOLDER_CURRENT": "Mevcut şifrenizi girin",
      "LABEL_NEW": "Yeni şifre",
      "PLACEHOLDER_NEW": "Yeni şifrenizi girin",
      "LABEL_VERIFY_NEW": "Yeni şifreyi doğrula",
      "PLACEHOLDER_VERIFY_NEW": "Yeni şifrenizi tekrar girin",
      "BUTTON_LABEL": "Şifreyi değiştir",
      "TOAST": {
        "SUCCESS": "Şifre değiştirildi. Yeni şifrenizle tekrar giriş yapın",
        "ERROR": "Şifre değiştirilirken hata oluştu"
      },
      "FORM_VALIDATION_MISMATCH": "Yeni şifreler eşleşmiyor"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Proje detayları",
    "SWI_SIGNED": "SWI imzalandı",
    "SWI_OPEN": "SWI açık",
    "SWI_SIGNED_COUNT": "{count} SWI imzalandı",
    "SWI_SIGNED_OF": "{total} SWI’den {signed} tanesi imzalandı",
    "REPORT_SAFETY_RISKS": "Güvenlik risklerini bildir",
    "SEE_SAFETY_REPORTS": "Güvenlik raporlarını aç",
    "CONTRACTOR": "Alt yüklenici",
    "CLIENT": "Müşteri",
    "SELECT": "Seç",
    "WORKERS": "Çalışanlar",
    "DESELECT": "Seçimi kaldır",
    "WORKERS_EMPTY_STATE": "Henüz bu projeye çalışan kaydolmadı.",
    "UNKNOWN_EMPLOYER": "İşveren bilinmiyor",
    "CERTIFICATES": "Gerekli proje sertifikaları",
    "TOOLBOXES": "Gerekli proje toolboxes",
    "TOOLBOXES_ALL_COMPLETED": "Gerekli tüm toolboxes tamamlandı",
    "ALERTS": "Mesajlar",
    "CREATE_ALERT": "Mesaj ekle",
    "ALERTS_EMPTY_STATE": "Bu proje için şu anda mesaj yok",
    "MAIN_OFFICE": "Genel merkez",
    "CHECK_IN": "Giriş yap",
    "CHECK_OUT": "Çıkış yap",
    "AT_WORK": "{count} işte",
    "REQUIREMENTS_CHECKLIST": "Proje gereksinimleri",
    "OVERWRITE_CHECKIN_TITLE": "Giriş yap",
    "OVERWRITE_CHECKIN_MESSAGE": "Şu anda \"{projectName}\" projesinde giriş yaptınız. Burada giriş yaparsanız o giriş sona erer.",
    "OVERWRITE_CHECKIN_CONFIRM": "Giriş yap",
    "OVERWRITE_CHECKIN_CANCEL": "İptal"
  },
  "PROJECT_SELECT": {
    "TITLE": "Proje seç",
    "PROJECT_NAME": "Proje adı",
    "PROJECT_FUNCTION": "Projedeki fonksiyon",
    "SELECT_AT_LEAST_ONE_FUNCTION": "En az bir fonksiyon seçin.",
    "EMPLOYEE": "Çalışan",
    "NEXT": "İleri",
    "ALREADY_CHECKED_IN_TITLE": "Zaten giriş yapıldı",
    "ALREADY_CHECKED_IN_MESSAGE": "Bu projede zaten giriş yaptınız. Yapmanız gereken bir şey yok.",
    "INVALID_CODE": "Bu proje kodu artık geçerli değil. Güncel kodu şantiye şefinden isteyin.",
    "REPORT_TO_FOREMAN_TITLE": "Şantiye şefine bildirin",
    "REPORT_TO_FOREMAN_MESSAGE": "Giriş yaptınız ancak bu projede kayıtlı değilsiniz. Hemen şantiye şefine bildirin."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Tüm gereklilikler karşılandı",
    "BUTTON": "Onayla",
    "TITLE": "Proje seçimini onayla"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Başarılı!",
    "SELECTED": "Projeye kaydoldunuz.",
    "DESELECTED": "Projeden kaydınızı sildiniz.",
    "BUTTON": "Ana Sayfa"
  },
  "CERTIFICATE": {
    "EXPIRED": "{date} tarihinde süresi doldu",
    "VALID_UNTIL": "{date} tarihine kadar geçerli",
    "EXPIRES_IN": "{duration} içinde süresi doluyor",
    "EXPIRES_SOON": "3 ay içinde süresi doluyor",
    "EXPIRES_NEVER": "Süresi hiç dolmuyor",
    "MISSING": "Henüz alınmadı",
    "PENDING": "İnceleme bekliyor",
    "REJECTED": "Reddedildi",
    "VIEW_DOCUMENT": "Belge",
    "VIEW_DOCUMENT_N": "Belge {n}",
    "REGISTERED_TO": "{name} adına kayıtlı"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Fotoğraf veya PDF ekle",
    "TAKE_PHOTO": "Fotoğraf çek",
    "CHOOSE_FROM_LIBRARY": "Kütüphaneden seç",
    "CHOOSE_PDF": "PDF seç",
    "REMOVE": "Kaldır",
    "CANCEL": "İptal"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Sertifika ekle",
    "CERTIFICATE": "Sertifika",
    "CERTIFICATE_NUMBER": "Sertifika numarası",
    "ISSUED_ON": "Düzenlenme tarihi",
    "EXPIRES_ON": "Son geçerlilik",
    "DOCUMENT": "Belge",
    "MISSING_FIELDS": "Lütfen bir organizasyon ve sertifika seçin.",
    "ERROR": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    "CHOOSER": {
      "IMPORT": "Kayıttan içe aktar",
      "UPLOAD": "Belge yükle"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Sertifika içe aktar",
    "LAST_NAME": "Soyad",
    "DATE_OF_BIRTH": "Doğum tarihi",
    "REGISTRY": "Kayıt",
    "CERTIFICATE_NUMBER": "Sertifika numarası",
    "MISSING_FIELDS": "Lütfen tüm alanları doldurun.",
    "SUCCESS": "Sertifika içe aktarıldı.",
    "STATUS": {
      "NOTFOUND": "Bu bilgiler için sertifika bulunamadı.",
      "REGISTRYERROR": "Kayda şu anda ulaşılamadı. Lütfen daha sonra tekrar deneyin."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Sertifika bulunamadı",
    "EXPIRED_CERTIFICATES": "Bazı sertifikalarınızın süresi dolmuş. Çalışmaya devam etmek için bunları yenileyin."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Şartlar ve koşullar",
    "PRIVACY_POLICY": "Gizlilik politikası",
    "APP_INFO": "Uygulama bilgisi",
    "AVG_STATEMENT": "GDPR beyanı"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{ay} other{ay}}",
    "DAYS": "{count, plural, =1{gün} other{gün}}",
    "SOON": "yakında"
  },
  "PERSON": {
    "FIRST_NAME": "Ad",
    "LAST_NAME": "Soyad",
    "EMAIL": "E-posta adresi",
    "FUNCTION": "Fonksiyon"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Fonksiyon",
    "PROJECT": "Mevcut proje",
    "CERTIFICATES": "Sertifikalar",
    "PROJECT_DETAILS": "Proje detayları",
    "UPDATE_PERSON_ACTION": "Detayları düzenle",
    "ASSIGN_TO_PROJECT_ACTION": "Projeme ata"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Profil fotoğrafı seç",
    "CANCEL": "İptal",
    "TAKE_PHOTO": "Fotoğraf çek",
    "CHOOSE_FROM_LIBRARY": "Kütüphaneden seç"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Raporlarım",
      "EMPTY_STATE_TITLE": "Rapor yok",
      "EMPTY_STATE_MESSAGE": "Kendinizin bildirdiği güvenlik riskleri burada görünecek.",
      "CREATE_REPORT": "Rapor oluştur"
    },
    "REPORT": {
      "ASSIGNED_TO": "{name} tarafından işleniyor",
      "REPORTED_BY": "{name} tarafından bildirildi",
      "REPORTED_BY_ANONYMOUS": "Anonim olarak bildirildi"
    },
    "PROJECT_REPORTS": {
      "TITLE": "{projectName} için raporlar",
      "EMPTY_STATE_TITLE": "Rapor yok",
      "EMPTY_STATE_MESSAGE": "Bu projede bildirilen güvenlik riskleri burada görünecek."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Rapor oluşturulamıyor",
      "DESCRIPTION": "Bir projeye kaydolmamışsınız. Rapor oluşturabilmek için kaydolun."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Rapor oluştur",
      "GENERAL": {
        "FORM_TITLE": "Genel",
        "CATEGORY": "Neyi bildirmek istiyorsunuz?",
        "IS_SOLVED": "Çözüldü mü?",
        "IS_URGENT": "Aciliyet",
        "IS_ANONYMOUS": "Anonim bildir",
        "PROJECT": "Hangi projede bu raporu oluşturmak istiyorsunuz?",
        "NO_PROJECTS": "Bir projeye kaydolmamışsınız. Rapor oluşturabilmek için kaydolun.",
        "CHOOSE_PROJECT": "Proje seç",
        "CONFIRM_PROJECT": "Bu projeye kayıtlı değilsiniz. Bu raporu oluşturmak istediğinizden emin misiniz?",
        "CONFIRM_PROJECT_BUTTON": "Evet, eminim",
        "VICTIMS": "Mağdurlar?",
        "ABSENTEEISM": "Devamsızlık",
        "HOSPITALISED": "Hastaneye kaldırıldı?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "CİDDİ BİR KAZA VEYA HASTANEE YATIRILMASINI GEREKTİREN BİR YARALANMA DURUMUNDA, HER ZAMAN ÖNCE ACİL SERVİSLERİ ARAYIN",
          "BETWEEN_PHONE_AND_URL": "VEYA ÇEVRİMİÇİ FORM ÜZERİNDEN:",
          "AFTER_LINK": "Bu rapordan sorumlu olan süpervizörünüzle, ustabaşınızla veya V&G koordinatörünüzle görüşün."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Durum",
        "PHOTOS": "Durum nasıl görünüyor?",
        "PHOTOS_PLACEHOLDER": "Bir veya daha fazla fotoğraf ekleyin veya açıklama yazın",
        "DESCRIPTION": "Durumu açıklayın",
        "SAFE_SITUATION_DESCRIPTION": "Güvenli durum",
        "RISK": "Risk",
        "DESCRIPTION_OF_SITUATION": "Durum açıklaması",
        "ACTIONS_TAKEN": "Alınan önlemler",
        "RISK_CATEGORY": {
          "LABEL": "Risk kategorisi",
          "PLACEHOLDER": "Kategori seçin",
          "REQUIRED": "Kategori zorunludur"
        }
      },
      "SUMMARY": {
        "TITLE": "Rapor gönderildi",
        "MESSAGE": "#{{id}} numaralı rapor gönderildi."
      },
      "SEND": "Gönder",
      "SUCCESS_TOAST": "Güvenlik raporu başarıyla oluşturuldu",
      "VALIDATION": {
        "MISSING_FIELDS": "Lütfen tüm zorunlu alanları doldurun"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Bir çalışana atanmadı",
      "ASSIGNED_TO_PERSON": "Çalışana atandı",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Çalışana ata",
      "DETAILS": "Detaylar",
      "TITLE": "{reportId} raporunu görüntüle",
      "PROJECT_NAME": "Proje",
      "REPORTER": "Bildiren",
      "ANONYMOUS_REPORTER": "Anonim bildiren",
      "UNKNOWN_AUTHOR": "Bilinmeyen yazar",
      "CATEGORY": "Rapor türü",
      "URGENCY": "Aciliyet",
      "SOLVED": "Çözüldü",
      "PHOTOS": "Fotoğraflar",
      "PHOTOS_EMPTY": "Bu rapor fotoğraf içermiyor",
      "DESCRIPTION": "Açıklama",
      "RISK": "Risk",
      "CREATED_AT": "Oluşturulma tarihi",
      "CREATE_COMMENT": "Yorum yap",
      "COMMENTS": "Yorumlar",
      "COMMENTS_EMPTY": "Henüz yorum yapılmadı",
      "COMMENT_BY": "{person} tarafından yorum",
      "COMMENT_CREATED": "Yorum başarıyla gönderildi",
      "LOGS": "Kayıtlar",
      "LOGS_EMPTY": "Henüz kayıt yok",
      "LOG": {
        "CREATED": "Rapor {actor} tarafından oluşturuldu",
        "STATUS_CHANGED": "Durum {actor} tarafından {newStatus} olarak değiştirildi",
        "COMMENTED": "Yorum {actor} tarafından yapıldı"
      },
      "NOT_IN_PROJECT": "Bildiren bu projeye kayıtlı değildi"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Kapat",
    "OPEN": "Aç"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Kaza",
    "UNSAFE_SITUATION": "Güvensiz",
    "SAFE_SITUATION": "Güvenli"
  },
  "REPORT_STATUS": {
    "NEW": "Okunmadı",
    "IN_PROGRESS": "Devam ediyor",
    "SOLVED": "Çözüldü",
    "ON_HOLD": "Duraklatıldı"
  },
  "NOTIFICATIONS": {
    "TITLE": "Bildirimler",
    "EMPTY_STATE_TITLE": "Bildirim yok",
    "EMPTY_STATE_MESSAGE": "Mevcut ve geçmişteki tüm önemli bildirimleri burada bulacaksınız",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Okundu olarak işaretle",
    "MARK_ALL_AS_READ": "Tümünü okundu olarak işaretle",
    "MARK_ALL_AS_READ_SUCCESS": "Tüm bildirimler okundu olarak işaretlendi",
    "DELETE": "Sil",
    "DELETE_SUCCESS": "Bildirim silindi"
  },
  "REPORT_TRANSITION": {
    "NEW": "Yeniye geri dön",
    "IN_PROGRESS": "İşleme al",
    "SOLVED": "Çözüldü olarak işaretle",
    "ON_HOLD": "Duraklat",
    "SOLVED_CONFIRMATION_TITLE": "Raporu çözüldü olarak işaretle?",
    "SOLVED_CONFIRMATION_MESSAGE": "Bu raporu çözüldü olarak işaretlemek istediğinizden emin misiniz?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Metninizi söyleyin",
    "BTN_LABEL": "Metin söyle",
    "PERMISSION_ERROR": "Metin söylenemez. İzin verilmedi. Telefonunuzun ayarlarını açın ve bu uygulama için metin söyleme izni verin.",
    "LISTENING": "Dinleniyor...",
    "USE_RESULT": "Sonucu gir"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Henüz sertifika almadınız",
    "PERSON_EMPTY_STATE": "Bu çalışan henüz sertifika almadı",
    "PROJECT_EMPTY_STATE": "Bu proje için ilgili sertifika yok",
    "PERSON_PROJECT_EMPTY_STATE": "Bu projede bu çalışan için ilgili sertifika yok"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Genel",
    "WEATHER": "Hava durumu",
    "LOGISTIC": "Lojistik",
    "SAFETY": "Güvenlik"
  },
  "ALERT_DETAILS": {
    "EDIT": "Düzenle",
    "TITLE": "Mesaj detayları",
    "CONFIRM": "Anladım",
    "DELETE_TITLE": "Mesajı sil",
    "DELETE_MESSAGE": "Bu mesajı silmek istediğinizden emin misiniz?",
    "DELETE_CONFIRM": "Sil",
    "DELETE_SUCCESS": "Mesaj silindi"
  },
  "ALERT_PLAYER": {
    "PLAY": "Oynat",
    "PAUSE": "Duraklat",
    "LANGUAGE": "Dil",
    "SEEK": "İlerleme",
    "FULLSCREEN": "Tam ekran"
  },
  "ALERT": {
    "CATEGORY": "Kategori",
    "TITLE": "Başlık",
    "DESCRIPTION": "Açıklama",
    "VALID_FROM": "Başlangıç",
    "VALID_UNTIL": "Bitiş",
    "FROM": "başlangıç",
    "UNTIL": "bitiş",
    "VIDEO": "Video",
    "REMOVE_VIDEO": "Videoyu kaldır",
    "TYPE": "Mesaj türü",
    "TYPE_TEXT": "Metin",
    "TYPE_VIDEO": "Video",
    "ADD_TARGET_AUDIENCE": "Hedef kitle ekle",
    "TARGET_AUDIENCE": "Hedef kitle",
    "TARGET_AUDIENCE_EVERYONE": "Herkes",
    "TARGET_AUDIENCE_MANAGEMENT": "Yönetim",
    "SELECT_TARGET_AUDIENCE": "Hedef kitle seç",
    "NO_FILE_SELECTED": "Dosya seçilmedi",
    "CHOOSE_FILE": "Dosya seç",
    "TRANSLATION": "Çeviri",
    "TRANSLATION_DESCRIPTION": "Bu videoyu çevir",
    "VIDEO_UPLOAD_FAILED": "Video yükleme başarısız",
    "AUDIENCE": {
      "MANAGEMENT": "Yönetim",
      "ORGANISATION": "Kuruluş:",
      "FUNCTION": "Görev:",
      "FUNCTION_GROUP": "Görev grubu:",
      "ADD_MANAGEMENT": "Yönetim",
      "ADD_ORGANISATION": "Kuruluş",
      "ADD_FUNCTION": "Görev veya grup",
      "SELECT_ORGANISATION": "Bir kuruluş seçin",
      "NO_ORGANISATIONS": "Bu projede kuruluş yok.",
      "LOADING_ORGANISATIONS": "Yükleniyor..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Mesaj ekle",
    "ACTION": "Mesaj oluştur",
    "SUCCESS_TOAST_MESSAGE": "Mesaj başarıyla oluşturuldu"
  },
  "EDIT_ALERT": {
    "TITLE": "Mesajı düzenle",
    "ACTION": "Değişiklikleri kaydet",
    "SUCCESS_TOAST_MESSAGE": "Mesaj başarıyla güncellendi"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Proje ata",
    "SUCCESS_TOAST_MESSAGE": "Proje ataması başarıyla güncellendi"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Proje ata",
    "SUCCESS_TOAST_MESSAGE": "Proje ataması başarılı"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Seçenek ara"
  },
  "CHECKLIST": {
    "COMPLETED": "Kontrol listesi başarıyla tamamlandı",
    "ERROR": "Kontrol listesi tamamlanırken bir şeyler ters gitti",
    "LIST_LABEL": "Kontrol listeleri",
    "ALL_COMPLETED": "Gerekli tüm kontrol listeleri tamamlandı",
    "COMPLETE": "Tamamla"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Şifre gereksinimleri:",
    "MIN_LENGTH": "En az {minLength} karakter",
    "UPPERCASE": "En az bir büyük harf",
    "LOWERCASE": "En az bir küçük harf",
    "DIGIT": "En az bir rakam",
    "SPECIAL_CHAR": "En az bir özel karakter"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Kök",
    "SEARCH_PLACEHOLDER": "Fonksiyon ara",
    "NO_RESULTS": "Fonksiyon bulunamadı",
    "WHOLE_CATEGORY": "Tüm grup: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "{moment} tarihinde imzalandı",
    "NO_SWI_SIGNATURE": "Henüz imzalanmadı",
    "SWI_SIGNATURE_ALT": "İmza",
    "SWI_SIGNATURE_FAILED": "İmza yüklenemedi",
    "TITLE": "Çalışan bilgileri",
    "ITEM_STATUS": {
      "PRESENT": "Mevcut",
      "MISSING": "Eksik",
      "EXPIRED": "Süresi dolmuş",
      "EXPIRED_GRACE_PERIOD": "Süresi dolmuş (ek süre)"
    },
    "CERTIFICATES": "Sertifikalar",
    "CHECKLISTS": "Kontrol listeleri",
    "SAFETY_INSTRUCTIONS": "Güvenlik Talimatları",
    "TOOLBOXES": "Araç kutuları",
    "NAME": "Ad",
    "VERIFIED_AGAINST": "{project} için doğrulandı",
    "BASIC_INFORMATION": "Temel bilgiler",
    "ILOP_CONTENT": "i-LOP içeriği",
    "NO_EMPLOYMENTS": "Bu çalışanın aktif istihdamı yok",
    "NO_ILOP_CONTENT": "Bu projede bu çalışan için ilgili i-LOP içeriği yok",
    "CHECK_IN": {
      "SINCE": "Giriş saati"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Fonksiyon",
      "FROM": "Başlangıç",
      "TO": "Bitiş"
    },
    "CERTIFICATE": {
      "NUMBER": "Numara",
      "ISSUED_ON": "Veriliş tarihi",
      "ISSUED_FOR": "Verilen kişi",
      "EXPIRES_ON": "Son geçerlilik"
    },
    "CONTENT": {
      "COMPLETED_ON": "Tamamlanma",
      "MEETING_ENDED": "Toplantı bitişi",
      "SIGNED": "İmzalandı"
    },
    "KVK": {
      "NUMBER": "KvK numarası",
      "DOCUMENT_DATE": "Belge tarihi",
      "VALID_UNTIL": "Geçerlilik tarihi",
      "DOCUMENT": "KvK belgesi"
    },
    "OPEN_DOCUMENT": "Aç",
    "OPEN_DOCUMENT_FAILED": "Belge açılamadı"
  },
  "GATE_ENTRY": {
    "TITLE": "Girişi kaydet",
    "GAPS_HINT": "Bu çalışanın eksik gereklilikleri var, bu yüzden içeri alınması bir istisnadır.",
    "NOT_CHECKED_IN_HINT": "Bu çalışan bu projeye giriş yapmamış. İçeri almak için girişini yapın veya girişi reddedin.",
    "CHECK_IN_WORKER": "Çalışanın girişini yap",
    "DECISION": {
      "VALID": "Geçerli",
      "EXCEPTION": "İstisna",
      "DENIED": "Reddedildi"
    },
    "REASON": {
      "HEADER_EXCEPTION": "İstisnanın gerekçesi",
      "HEADER_DENIED": "Girişi reddetme gerekçesi",
      "MESSAGE": "Bu, adınız ve saatle birlikte kaydedilir.",
      "PLACEHOLDER": "Gerekçeyi açıklayın",
      "CONFIRM": "Kaydet"
    },
    "REGISTERED": "Giriş kaydedildi"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "İstihdam Geçmişi",
      "NO_EMPLOYMENTS": "İstihdam geçmişi bulunamadı.",
      "PRESENT": "Günümüz",
      "ACTIVE": "Aktif",
      "NOT_YET_ACTIVE": "Henüz aktif değil",
      "LOAD_ERROR": "İstihdam geçmişi yüklenirken bir hata oluştu.",
      "STATUS_FOR_ADMIN_REVIEW": "İnceleme altında",
      "STATUS_FOR_USER_REVIEW": "İstihdamınızı doğrulayın",
      "ADD_EMPLOYMENT": "Ekle",
      "REVIEW_NOTICE": "İstihdam geçmişinizde bazı istihdamlar inceleme altında. Çalışmaya devam etmek için lütfen bunları gözden geçirin.",
      "REVIEW_NOTICE_ACTION": "Gözden geçirmek için dokunun.",
      "REVIEW_OPEN": "İncele",
      "REVIEW_DETAILS_TITLE": "İstihdamı gözden geçir",
      "FUNCTION": "Fonksiyon",
      "START_DATE": "Başlangıç tarihi",
      "END_DATE": "Bitiş tarihi",
      "MANAGERIAL": "Yönetici",
      "YES": "Evet",
      "NO": "Hayır",
      "ACCEPT": "Kabul et",
      "REJECT": "Reddet",
      "REVIEW_ACCEPT_SUCCESS": "İstihdam başarıyla kabul edildi.",
      "REVIEW_REJECT_SUCCESS": "İstihdam başarıyla reddedildi.",
      "REVIEW_ERROR": "İstihdamı gözden geçirirken bir hata oluştu."
    },
    "DETAIL": {
      "TITLE": "İstihdam",
      "NOT_FOUND": "Bu istihdam bulunamadı."
    },
    "CREATE": {
      "TITLE": "İstihdam ekle",
      "ORGANISATION": "Organizasyon",
      "SEARCH_ORGANISATION": "Organizasyon ara",
      "NO_ORGANISATIONS": "Organizasyon bulunamadı.",
      "FUNCTION": "Fonksiyon",
      "START_DATE": "Başlangıç tarihi",
      "END_DATE": "Bitiş tarihi",
      "MANAGERIAL_LABEL": "Yönetici fonksiyonu",
      "BUSINESS_REGISTRY_NUMBER": "Ticaret sicil numarası",
      "SAVE": "Kaydet",
      "SAVE_SUCCESS": "İstihdam başarıyla eklendi.",
      "SAVE_ERROR": "İstihdam eklenirken bir hata oluştu.",
      "LOAD_ORGANISATIONS_ERROR": "Organizasyonlar yüklenirken bir hata oluştu.",
      "END_DATE_BEFORE_START": "Bitiş tarihi, başlangıç tarihinden önce olamaz.",
      "ORGANISATION_UNAVAILABLE": "Bu işveren artık mevcut değil. Başka birini seçin.",
      "FUNCTION_UNKNOWN": "Bu fonksiyon artık mevcut değil. Başka birini seçin.",
      "BINDING_CONFLICT": "Bu işveren, e-posta adresinizle başka bir hesap altında kayıtlı birini zaten tanıyor. Bunun yerine sizi davet etmelerini isteyin.",
      "IDENTITY_INCOMPLETE": "Hesabınızda adınız veya e-posta adresiniz eksik olduğundan bir işveren sizi henüz kaydedemiyor. Tamamlamak için Yivi ile giriş yapın.",
      "REQUEST_ALREADY_PENDING": "Bu işverende zaten bekleyen bir talebiniz var. Yanıt vermelerini bekleyin.",
      "INVITATION_PENDING": "Bu işveren sizi zaten davet etti. Bu daveti istihdam geçmişinizden kabul edin veya reddedin."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Liste",
      "REGISTRATION": "Kayıt"
    },
    "EMPTY_STATE": "Mevcut araç kutusu yok",
    "LAST_UPDATED": "Güncellendi",
    "VIEW_DOCUMENT": "Belgeyi görüntüle",
    "ASYNC": {
      "COMPLETED": "Toolbox tamamlandı",
      "ERROR_COMPLETING": "Toolbox tamamlanamadı"
    },
    "FOLLOWED": {
      "TITLE": "Tamamlanan toolboxlar",
      "LINK": "Tamamlanan toolboxları görüntüle",
      "FILTER_CATEGORY": "Kategori",
      "FILTER_TYPE": "Tür",
      "TYPE_SYNCHRONOUS": "Senkron",
      "TYPE_ASYNCHRONOUS": "Asenkron",
      "TYPE_MANUAL": "Manuel",
      "NOT_AVAILABLE": "Artık mevcut değil",
      "EMPTY_STATE": "Henüz hiçbir toolbox tamamlamadınız",
      "EMPTY_FILTERED": "Bu filtrelere uyan tamamlanmış toolbox yok"
    },
    "MEETING": {
      "HOST_MEETING": "Toolbox toplantısı başlat",
      "START_ANOTHER_TITLE": "Başka bir toplantı başlatılsın mı?",
      "START_ANOTHER_MESSAGE": "Zaten devam eden {count, plural, =1{bir toolbox toplantınız} other{# toolbox toplantınız}} var. Bir tane daha başlatılsın mı?",
      "START_ANOTHER_CONFIRM": "Başka bir tane başlat",
      "ONLY_MANAGERIAL_CAN_HOST": "Yalnızca yöneticiler bir toolbox toplantısına ev sahipliği yapabilir",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Yalnızca yöneticiler bir toolbox toplantısını yönetebilir",
      "VIEW_ACTIVE_MEETING": "Aktif toplantıyı görüntüle",
      "SELECT_ACTIVE_MEETING": "Bir toplantı seçin",
      "MANUAL": {
        "START_BUTTON": "Manuel toplantıyı başlat",
        "DESCRIPTION": "Yönetici olarak ekibiniz için yeni bir manuel toolbox toplantısı başlatın.",
        "START_TITLE": "Manuel toplantıyı başlat",
        "ORGANISATION": "Organizasyon",
        "ORGANISATION_PLACEHOLDER": "Bir organizasyon seçin",
        "TITLE": "Başlık",
        "TITLE_PLACEHOLDER": "Bir başlık girin",
        "DESCRIPTION_PLACEHOLDER": "İsteğe bağlı açıklama",
        "START_MISSING_FIELDS": "Lütfen tüm zorunlu alanları doldurun",
        "TITLE_REQUIRED": "Başlık zorunludur",
        "TITLE_NOT_ALLOWED": "Başlık yalnızca manuel toplantılar için değiştirilebilir",
        "END_BEFORE_START": "Bitiş zamanı başlangıç zamanından önce olamaz",
        "ACTIVE_LIST_TITLE": "Toolbox toplantılarınız",
        "ACTIVE_BADGE": "Devam ediyor",
        "PLANNED_BADGE": "Planlandı",
        "CONTINUE_BUTTON": "Bu toplantıya devam et"
      },
      "TITLE": "Toolbox toplantısı",
      "PARTICIPANTS": "Katılımcılar",
      "NO_PARTICIPANTS": "Henüz katılımcı yok",
      "EXTERNAL_PARTICIPANT": "harici",
      "INFORMATION": "Bilgi",
      "START_DATE": "Başlangıç tarihi",
      "END_DATE": "Bitiş tarihi",
      "DESCRIPTION": "Açıklama",
      "FINISH_MEETING": "Toplantıyı bitir",
      "EDIT_MEETING": "Toplantıyı düzenle",
      "SAVE": "Kaydet",
      "CANCEL": "İptal",
      "FINISH_CONFIRMATION_TITLE": "Toplantı bitirilsin mi?",
      "FINISH_CONFIRMATION_MESSAGE": "Bu toolbox toplantısını bitirmek istediğinizden emin misiniz?",
      "MEETING_ENDED_TITLE": "Toplantı bitti",
      "MEETING_ENDED_MESSAGE": "Bu toplantı {endTime} tarihinde {finishedByName} tarafından bitirildi",
      "MEETING_ALREADY_STARTED": "Başka biri tarafından bir toplantı zaten başlatıldı",
      "ERROR_POLLING_MEETING": "Toplantılar kontrol edilirken bir hata oluştu",
      "ERROR_STARTING_MEETING": "Toplantı başlatılamadı",
      "ERROR_LOADING_MEETING": "Toplantı yüklenemedi",
      "ERROR_UPDATING_MEETING": "Toplantı güncellenemedi",
      "ERROR_FINISHING_MEETING": "Toplantı bitirilemedi",
      "ERROR_END_BEFORE_START": "Bitiş saati başlangıç saatinden önce olamaz",
      "SCAN_QR_CODE": "QR Kodu Tara",
      "RETRY_SCAN": "Tekrar Tara",
      "SCAN_TO_JOIN": "Katılmak için tara",
      "JOIN_TOOLBOX_MEETING": "Toolbox toplantısına katıl",
      "JOIN_DESCRIPTION": "Bir QR kodu tarayarak veya bir toplantı kodu girerek mevcut bir toolbox toplantısına katılın.",
      "QR_SCAN_WRONG_MEETING": "Bu QR kodu farklı bir toplantı için",
      "QR_SCAN_ALREADY_PARTICIPANT": "Bu toplantıya zaten katılımcısınız",
      "QR_SCAN_INVALID": "Geçersiz QR kodu formatı",
      "QR_SCAN_ERROR": "Taramada bir hata oluştu",
      "QR_SCAN_NO_PERMISSION": "QR kodları taramak için kamera izni gereklidir",
      "SUCCESSFULLY_JOINED": "Toplantıya başarıyla katıldınız",
      "ADD_PARTICIPANT": {
        "TITLE": "Katılımcı ekle",
        "CHOOSE_METHOD": "Bu toolbox toplantısına bir katılımcı eklemek için nasıl istediğinizi seçin: i-LOP QR kodlarını tarayın veya manuel olarak bir isim girin",
        "SCAN_QR_CODE": "QR kod tara",
        "MANUAL": "Manuel",
        "MANUAL_ENTRY": "Manuel giriş",
        "OR": "veya",
        "FIRST_NAME": "Ad",
        "LAST_NAME": "Soyad",
        "FIRST_NAME_PLACEHOLDER": "Adı girin",
        "LAST_NAME_PLACEHOLDER": "Soyadı girin",
        "CONFIRM": "Onayla",
        "ADDING": "Ekleniyor...",
        "SUCCESS": "Katılımcı başarıyla eklendi",
        "ERROR": "Katılımcı eklenemedi",
        "MEETING_NOT_FOUND": "Toplantı bulunamadı",
        "ALREADY_PARTICIPANT": "Bu kişi zaten toplantının katılımcısı",
        "MEETING_INACTIVE": "Toplantı aktif değil",
        "QR_VERIFY_PERMISSION_ERROR": "Bu QR kodunu doğrulama izniniz yok. Bunun yerine manuel giriş kullanın.",
        "MISSING_PARAMETERS": "Navigasyon için gerekli parametreler eksik",
        "NAVIGATION_ERROR": "Katılımcı ekleme sayfasına gidilemedi",
        "PERSON_NOT_IN_ORGANISATION": "Taranan kişi organizasyonunuza ait değil",
        "PERSON_NOT_BOUND": "Bu kişinin henüz bir uygulama hesabı yok. Onu harici katılımcı olarak ekleyin.",
        "PERSON_BINDING_CONFLICT": "Bu kişi birden fazla uygulama hesabıyla ilişkili olduğundan eklenemiyor. Yöneticinizle iletişime geçin.",
        "NO_PERSON_RECORD": "Bu çalışanın hesabı var ancak henüz bir kuruluşta çalışmıyor, bu nedenle katılımcı olarak eklenemez. Bunun yerine harici katılımcı olarak ekleyin."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "İmza",
    "INSTRUCTIONS": "Lütfen aşağıya imza atın",
    "CLEAR": "Temizle",
    "CONFIRM": "Onayla"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Giriş saati:",
    "LAST_CHECKED_OUT_AT": "Son çıkış saati:",
    "NOT_CHECKED_IN": "Giriş yapılmadı",
    "CERTIFICATES": "Sertifikalar",
    "MORE_CERTIFICATES": "{count} daha fazla",
    "ADD_CERTIFICATE": "Sertifika ekle"
  },
  "ZZP_COMPANY": {
    "TITLE": "Şirket profili (ZZP)",
    "INTRO": "Tek kişilik şirketiniz (ZZP) için bir profil oluşturun.",
    "COMPANY_NAME": "Şirket adı",
    "KVK_NUMBER": "Ticaret Odası (KvK) numarası",
    "SAVE": "Kaydet",
    "TOAST": {
      "SAVED": "Şirket profili kaydedildi",
      "ERROR": "Şirket profili kaydedilirken bir hata oluştu",
      "LOAD_ERROR": "Şirket profili yüklenirken bir hata oluştu"
    },
    "KVK_EXTRACT": {
      "LABEL": "KvK belgesi",
      "ADD": "KvK belgesi ekle",
      "VIEW": "KvK belgesini görüntüle",
      "REMOVE": "Kaldır",
      "UPLOADED": "KvK belgesi yüklendi",
      "REMOVED": "KvK belgesi kaldırıldı",
      "INVALID_TYPE": "Yalnızca PDF veya resim dosyalarına izin verilir",
      "DOCUMENT_DATE": "KvK belgesindeki tarih",
      "VALID_UNTIL": "Geçerlilik tarihi",
      "OUT_OF_DATE": "Bu KvK belgesi çok eski. Daha yeni bir belge yükleyin.",
      "NEEDS_DATE": "Belgenin geçerli sayılması için üzerindeki tarihi girin.",
      "NEEDS_DOCUMENT": "Tarihin geçerli sayılması için KvK belgesini yükleyin."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Yeni SWI",
    "STEP_OF": "Adım {step} / {total}",
    "NEXT": "İleri",
    "LOADING": "Yükleniyor…",
    "SAVED": "Start Werk Instructie kaydedildi",
    "STEP_LABEL": {
      "PERIOD": "Tarih veya dönem",
      "MESSAGES": "Mesajlar: bugünün güvenlik talimatları",
      "INSTRUCTIONS": "Talimatlar",
      "TOOLBOXES": "Toolbox’lar",
      "CHECKLISTS": "Kontrol listeleri",
      "SUMMARY": "Özet",
      "NEW_MESSAGE": "Yeni mesaj"
    },
    "PERIOD": {
      "SINGLE_DAY": "Bir gün",
      "RANGE": "Dönem",
      "DATE": "Tarih",
      "FROM": "Başlangıç",
      "UNTIL_INCLUSIVE": "Bitiş dahil",
      "ONE_PER_DAY_HINT": "Bu projede günde yalnızca bir SWI etkin olabilir.",
      "TAKEN_DAYS_HINT": "İşaretli günlerde zaten bir SWI var ve seçilemez.",
      "OVERLAP": "Bu dönemde zaten bir Start Werk Instructie var. Başka tarihler seç."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Mesajlar",
      "MESSAGES_HINT": "Yalnızca Güvenlik türündeki mesajlar gösterilir. Birden fazla seçebilirsin.",
      "MESSAGES_EMPTY": "Bu projede güncel güvenlik mesajı yok.",
      "INSTRUCTIONS_HEADING": "Talimatlar",
      "INSTRUCTIONS_HINT": "Yalnızca SWI’de kullanılabilir olarak işaretlenen içerik gösterilir.",
      "INSTRUCTIONS_EMPTY": "SWI için talimat yok.",
      "TOOLBOXES_HEADING": "Toolbox’lar",
      "TOOLBOXES_HINT": "Yalnızca SWI’de kullanılabilir olarak işaretlenen içerik gösterilir.",
      "TOOLBOXES_EMPTY": "SWI için toolbox yok.",
      "CHECKLISTS_HEADING": "Kontrol listeleri",
      "CHECKLISTS_HINT": "Yalnızca SWI’de kullanılabilir olarak işaretlenen içerik gösterilir.",
      "CHECKLISTS_EMPTY": "SWI için kontrol listesi yok.",
      "MEDIUM_VIDEO": "Video",
      "MEDIUM_DOCUMENT": "Okunacak"
    },
    "SUMMARY": {
      "CHANGE": "Değiştir",
      "NOTHING_SELECTED": "Hiçbir şey seçilmedi",
      "NO_CONTENT": "En az bir mesaj, talimat, toolbox veya kontrol listesi seç.",
      "SAVE": "Kaydet",
      "PERIOD_SINGLE": "{date} tarihli Start Werk Instructie",
      "PERIOD_RANGE": "{from} - {to} tarihli Start Werk Instructie"
    },
    "REPEAT": {
      "HEADING": "Tekrar",
      "FIRST_ENTRY": "Yalnızca şantiyeye ilk girişte",
      "EVERY_ENTRY": "Şantiyeye her girişte",
      "AFTER_ABSENCE": "Bir aradan sonra yeniden izlenmeli",
      "ABSENCE_DAYS": "Şu günden uzun (gün)",
      "ABSENCE_DAYS_RANGE": "{min} ile {max} arasında bir sayı gir."
    },
    "EDIT_TITLE": "SWI’yi düzenle",
    "NEW_MESSAGE": {
      "ACTION": "Yeni mesaj (metin veya video)",
      "OR_PICK": "Veya mevcut mesajları seçin",
      "HINT": "Dönem ve kategori Start Werk Instructie üzerinden alınır.",
      "ADD": "Mesaj ekle",
      "SAVE": "Mesajı kaydet",
      "REMOVE": "Mesajı kaldır"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Aşağıdakilerin tümünü tamamlayın, ardından imzalayın.",
      "PROGRESS": "{total} öğeden {done} tanesi tamamlandı",
      "EMPTY": "Bu projede bugün takip edilecek bir şey yok.",
      "LOAD_FAILED": "Start Werk Instructie yüklenemedi.",
      "RETRY": "Tekrar dene",
      "NEXT": "Sonraki adım",
      "SIGN_INTRO": "Bilgilerinizi kontrol edin ve imzalayın.",
      "NAME": "Ad",
      "DATE": "Tarih",
      "COMPANY": "Şirket",
      "FUNCTION": "Görev",
      "CLEAR": "Temizle",
      "SIGN_AND_FINISH": "İmzala ve bitir",
      "SIGNED": "Start Werk Instructie imzalandı",
      "SIGN_FAILED": "İmzalama tamamlanamadı. Tekrar deneyin."
    },
    "CARD": {
      "HEADING": "Aktif Start Werk Instructie",
      "STATUS_ACTIVE": "Aktif",
      "STATUS_PLANNED": "Planlandı",
      "PERIOD_RANGE": "{from} - {to}",
      "REPEAT_EVERY_ENTRY": "sahaya her girişte",
      "REPEAT_FIRST_ENTRY": "yalnızca ilk girişte"
    }
  }
}
